import { IPaginationResponse } from "../types";
import { INoboEvent, INoboEventParams, INoboEventsParams } from "./types";
import { rootApi } from "../rootApi";

export const noboEventApis = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    noboEvents: builder.query<
      IPaginationResponse<INoboEvent>,
      INoboEventsParams
    >({
      query: ({ limit, ordering, offset, tab, type, issuerId }) => ({
        url: `nobo-events/`,
        params: {
          limit,
          ordering,
          offset,
          tab,
          type: type || undefined,
          issuer_id: issuerId || undefined,
        },
      }),
      providesTags: ["noboEvents"],
    }),
    noboEvent: builder.query<INoboEvent, INoboEventParams>({
      query: ({ id }) => ({
        url: `nobo-events/${id}/`,
      }),
      providesTags: (_result, _, arg) => [{ type: "noboEvents", id: arg.id }],
    }),
  }),
});

export const { useNoboEventQuery, useNoboEventsQuery } = noboEventApis;
